/* ─── 沉浸式页面配置（集中一处，Header 与状态栏配色共用）───
 * 「沉浸页」= 移动端顶端有深色全宽 hero、header 透明浮于其上（下滑变毛玻璃胶囊）的页面。
 * iOS Safari 状态栏顶条颜色由 meta[name=theme-color] 决定：沉浸页需把它设成 hero 深色，
 * 否则白色顶条压在深色 hero 上、破坏沉浸（这正是「首页/数据来源没实现、其它页正常」的根因）。
 */

/** 沉浸页顶端 hero 的深色（用作状态栏 theme-color） */
export const IMMERSIVE_STATUS_COLOR = '#050f24';

export interface ImmersiveConfig {
  /** 移动端「透明→胶囊」滚动过渡距离，写入 CSS 变量 --zx-hd-range；
   *  null = 用默认(56/50svh，适配首页 100svh 大 hero)。 */
  range: string | null;
  /** 状态栏保持 hero 深色的滚动阈值(视口高比例)；滚过此距离即恢复主题色。
   *  大 hero(首页)取大值、矮 hero(数据来源)取小值，尽量与 hero 实际高度吻合。 */
  statusThresholdVh: number;
}

export const IMMERSIVE_ROUTES: Record<string, ImmersiveConfig> = {
  '/': { range: null, statusThresholdVh: 0.55 },
  '/data-sources': { range: '22svh', statusThresholdVh: 0.22 },
};

export function immersiveConfig(pathname: string): ImmersiveConfig | undefined {
  return IMMERSIVE_ROUTES[pathname];
}
